<template>
    <div class="gallery-layout">
        <!-- Header -->

        <div class="">
            <!-- Carousel Principal (Lado Izquierdo) -->
            <div class="">
                <div id="mainCarousel" class="carousel slide" data-ride="carousel">
                    <div class="carousel-inner">
                        <div 
                            v-for="(image, index) in images" 
                            :key="'main-' + index"
                            class="carousel-item"
                            :class="{ 'active': index === activeIndex }"
                        >
                            <div 
                                class="image-zoom-container"
                                @click="toggleZoom"
                            >
                                <img
                                    :src="image"
                                    :alt="'capwashmx ' + (index + 1)"
                                    class="main-image"
                                    ref="zoomImages"
                                />
                                <div class="zoom-indicator">
                                    <i class="fa fa-expand"></i>
                                </div>
                            </div>
                            <div class="image-info">
                                <span class="image-counter">{{ index + 1 }} / {{ images.length }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Controls - Flechas delgadas -->
                    <a class="carousel-control-prev" href="#mainCarousel" data-slide="prev">
                        <span class="carousel-control-prev-icon">
                            <i class="fa fa-chevron-left"></i>
                        </span>
                    </a>
                    <a class="carousel-control-next" href="#mainCarousel" data-slide="next">
                        <span class="carousel-control-next-icon">
                            <i class="fa fa-chevron-right"></i>
                        </span>
                    </a>
                </div>
            </div>


        </div>

        <!-- Modal de Zoom Pantalla Completa -->
        <div v-if="isZoomed" class="zoom-modal" @click="toggleZoom">
            <div class="zoom-modal-content" @click.stop>
                <div class="zoom-header">
                    <span class="zoom-counter">{{ activeIndex + 1 }} / {{ images.length }}</span>
                    <button class="zoom-close-btn" @click="toggleZoom">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                
                <div class="zoom-image-container">
                    <img
                        :src="images[activeIndex]"
                        :alt="'capwashmx ' + (activeIndex + 1)"
                        class="zoom-full-image"
                        @mousemove="handleZoomMove"
                        @wheel="handleZoomWheel"
                        ref="zoomFullImage"
                    />
                </div>

                <div class="zoom-controls">
                    <button class="zoom-nav-btn" @click="prevSlide" title="Anterior">
                        <i class="fa fa-chevron-left"></i>
                    </button>
                    
                    
                    <button class="zoom-nav-btn" @click="nextSlide" title="Siguiente">
                        <i class="fa fa-chevron-right"></i>
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FullscreenZoomGallery',
    data() {
        return {
            images: [],
            activeIndex: 0,
            isZoomed: false,
            zoomScale: 1,
            maxZoom: 3,
            minZoom: 1
        };
    },
    mounted() {
        this.loadImages();
        this.setupCarouselEvents();
        this.setupEscapeListener();
    },
    beforeUnmount() {
        this.removeEscapeListener();
    },
    methods: {
        loadImages() {
            const images = [];
            for (let i = 1; i <= 339; i++) {
                const number = i.toString().padStart(2, '0');
                try {
                    const imagePath = require(`../img/antes_despues/antes_despues_${number}.png`);
                    images.push(imagePath);
                } catch (error) {
                    console.error(`No se pudo cargar la imagen ${number}:`, error);
                }
            }
            this.images = images;
        },

        setupCarouselEvents() {
            const carousel = document.getElementById('mainCarousel');
            if (carousel) {
                carousel.addEventListener('slide.bs.carousel', (event) => {
                    this.activeIndex = event.to;
                });
                
                carousel.addEventListener('slid.bs.carousel', (event) => {
                    this.activeIndex = event.to;
                });
            }
        },

        setupEscapeListener() {
            document.addEventListener('keydown', this.handleKeydown);
        },

        removeEscapeListener() {
            document.removeEventListener('keydown', this.handleKeydown);
        },

        handleKeydown(event) {
            if (event.key === 'Escape' && this.isZoomed) {
                this.toggleZoom();
            } else if (this.isZoomed) {
                if (event.key === 'ArrowLeft') {
                    this.prevSlide();
                } else if (event.key === 'ArrowRight') {
                    this.nextSlide();
                }
            }
        },

        goToSlide(index) {
            this.activeIndex = index;
            const carousel = document.getElementById('mainCarousel');
            if (carousel) {
                const indicator = carousel.querySelector(`[data-slide-to="${index}"]`);
                if (indicator) {
                    indicator.click();
                }
            }
        },

        toggleZoom() {
            this.isZoomed = !this.isZoomed;
            if (this.isZoomed) {
                document.body.style.overflow = 'hidden';
                this.zoomScale = 1; // Reset zoom al abrir
            } else {
                document.body.style.overflow = '';
            }
        },

        prevSlide() {
            if (this.activeIndex > 0) {
                this.activeIndex--;
            } else {
                this.activeIndex = this.images.length - 1;
            }
            this.zoomScale = 1; // Reset zoom al cambiar slide
        },

        nextSlide() {
            if (this.activeIndex < this.images.length - 1) {
                this.activeIndex++;
            } else {
                this.activeIndex = 0;
            }
            this.zoomScale = 1; // Reset zoom al cambiar slide
        },

        handleZoomMove(event) {
            if (this.zoomScale <= 1) return;

            const image = this.$refs.zoomFullImage;
            if (!image) return;

            const container = event.currentTarget;
            const containerRect = container.getBoundingClientRect();
            
            const x = event.clientX - containerRect.left;
            const y = event.clientY - containerRect.top;
            
            const xPercent = (x / containerRect.width) * 100;
            const yPercent = (y / containerRect.height) * 100;
            
            image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        },

        handleZoomWheel(event) {
            event.preventDefault();
            
            const delta = Math.sign(event.deltaY);
            const newScale = this.zoomScale - (delta * 0.2);
            
            this.zoomScale = Math.max(this.minZoom, Math.min(this.maxZoom, newScale));
            
            const image = this.$refs.zoomFullImage;
            if (image) {
                image.style.transform = `scale(${this.zoomScale})`;
                
                // Reset transform origin cuando no hay zoom
                if (this.zoomScale === 1) {
                    image.style.transformOrigin = 'center center';
                }
            }
        },

        resetZoom() {
            this.zoomScale = 1;
            const image = this.$refs.zoomFullImage;
            if (image) {
                image.style.transform = 'scale(1)';
                image.style.transformOrigin = 'center center';
            }
        }
    }
};
</script>

<style scoped>
.gallery-layout {
    width: 100%;
    margin: 0 auto;
    padding: 20px;
}

/* Header */
.gallery-header {
    text-align: center;
    margin-bottom: 40px;
}

.gallery-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 10px;
}

.gallery-subtitle {
    font-size: 1.1rem;
    color: #7f8c8d;
    font-weight: 300;
}

/* Contenido Principal - Layout Lateral */
.gallery-content {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 30px;
    align-items: start;
}

/* Carousel Principal */
.main-carousel-container {
    background: white;
    border-radius: 10px;
    padding: 0;
    position: relative;
}

.carousel-inner {
    border-radius: 10px;
    overflow: hidden;
}

/* Contenedor de Zoom */
.image-zoom-container {
    position: relative;
    cursor: pointer;
    overflow: hidden;
    background: #f8f9fa;
}

.main-image {
    width: 100%;
    height: 600px;
    object-fit: contain;
    object-position: center;
    transition: transform 0.3s ease;
}

.image-zoom-container:hover .main-image {
    transform: scale(1.02);
}

/* Indicador de Zoom */
.zoom-indicator {
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 8px;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.image-zoom-container:hover .zoom-indicator {
    opacity: 1;
}

.zoom-indicator i {
    font-size: 0.8rem;
}

/* Info de la imagen */
.image-info {
    padding: 15px;
    text-align: center;
    background: white;
    border-top: 1px solid #e9ecef;
}

.image-counter {
    font-weight: 600;
    color: #2c3e50;
    font-size: 1rem;
}

/* Controls - Flechas delgadas */
.carousel-control-prev,
.carousel-control-next {
    width: 60px;
    background: transparent;
    opacity: 0.7;
    transition: opacity 0.3s ease;
}

.carousel-control-prev:hover,
.carousel-control-next:hover {
    opacity: 1;
    background: transparent;
}

.carousel-control-prev-icon i,
.carousel-control-next-icon i {
    color: rgba(0, 0, 0, 0.7);
    font-size: 1.5rem;
    filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.8));
}

.carousel-control-prev {
    left: 10px;
}

.carousel-control-next {
    right: 10px;
}

/* Sidebar de Miniaturas */
.thumbnails-sidebar {
    background: white;
    border-radius: 10px;
    padding: 20px;
    height: fit-content;
    position: sticky;
    top: 20px;
    border: 1px solid #e9ecef;
}

.thumbnails-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e9ecef;
}

.thumbnails-title {
    font-size: 1.4rem;
    color: #2c3e50;
    font-weight: 600;
    margin: 0;
}

.thumbnails-counter {
    display: flex;
    align-items: center;
    background: #f8f9fa;
    color: #2c3e50;
    padding: 6px 12px;
    border-radius: 15px;
    font-weight: 600;
    font-size: 0.9rem;
    border: 1px solid #e9ecef;
}

/* Grid de Miniaturas */
.thumbnails-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    max-height: 600px;
    overflow-y: auto;
    padding-right: 5px;
}

.thumbnails-grid::-webkit-scrollbar {
    width: 2px;
}

.thumbnails-grid::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.thumbnails-grid::-webkit-scrollbar-thumb {
    background: #d1d1d1;
}

.thumbnail-card {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid #e9ecef;
}

.thumbnail-card:hover {
    border-color: #3498db;
}

.thumbnail-card.active {
    border-color: #3498db;
    background: #f8f9fa;
}

.thumbnail-image {
    width: 100%;
    height: 80px;
    object-fit: cover;
    object-position: center;
}

.thumbnail-number {
    padding: 6px;
    text-align: center;
    font-weight: 600;
    color: #2c3e50;
    font-size: 0.8rem;
    background: white;
    border-top: 1px solid #f8f9fa;
}

/* Modal de Zoom Pantalla Completa */
.zoom-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    cursor: pointer;
}

.zoom-modal-content {
    width: 95vw;
    height: 95vh;
    background: #1a1a1a;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    cursor: default;
    position: relative;
}

.zoom-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: rgba(0, 0, 0, 0.8);
    border-bottom: 1px solid #333;
}

.zoom-counter {
    color: white;
    font-weight: 600;
    font-size: 1.1rem;
}

.zoom-close-btn {
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.3s ease;
}

.zoom-close-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.zoom-image-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 20px;
}

.zoom-full-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    transition: transform 0.1s ease;
    cursor: move;
}

.zoom-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: rgba(0, 0, 0, 0.8);
    border-top: 1px solid #333;
}

.zoom-nav-btn {
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border: none;
    border-radius: 8px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.3s ease;
    font-size: 1.2rem;
}

.zoom-nav-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.zoom-actions {
    display: flex;
    gap: 10px;
}

.zoom-action-btn {
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border: none;
    border-radius: 8px;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.3s ease;
    font-size: 1rem;
}

.zoom-action-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.zoom-instructions {
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 10px 20px;
    border-radius: 20px;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 10px;
}

.zoom-instructions i {
    font-size: 0.8rem;
}

/* Responsive Design */
@media (max-width: 1024px) {
    .gallery-content {
        grid-template-columns: 1fr;
        gap: 20px;
    }
    
    .thumbnails-sidebar {
        position: static;
    }
    
    .thumbnails-grid {
        grid-template-columns: repeat(4, 1fr);
        max-height: 250px;
    }
    
    .main-image {
        height: 500px;
    }
}

@media (max-width: 768px) {
    .gallery-layout {
        padding: 15px;
    }
    
    .gallery-title {
        font-size: 2rem;
    }
    
    .main-image {
        height: 400px;
    }
    
    .thumbnails-grid {
        grid-template-columns: repeat(3, 1fr);
    }
    
    .thumbnail-image {
        height: 70px;
    }
    
    .zoom-indicator {
        opacity: 1;
        font-size: 0.8rem;
        padding: 6px 12px;
        bottom: 50px;
    }
    
    .zoom-modal-content {
        width: 100vw;
        height: 100vh;
        border-radius: 0;
    }
    
    .zoom-instructions {
        bottom: 100px;
        font-size: 0.8rem;
    }
}

@media (max-width: 480px) {
    .gallery-title {
        font-size: 1.8rem;
    }
    
    .main-image {
        height: 300px;
    }
    
    .thumbnails-grid {
        grid-template-columns: repeat(2, 1fr);
    }
    
    .thumbnail-image {
        height: 60px;
    }
    
    .thumbnails-header {
        flex-direction: column;
        gap: 10px;
        text-align: center;
    }
    
    .zoom-indicator {
        bottom: 40px;
    }
    
    .zoom-controls {
        padding: 15px;
    }
    
    .zoom-nav-btn,
    .zoom-action-btn {
        width: 40px;
        height: 40px;
        font-size: 1rem;
    }
}
</style>